import axios from 'axios'
import {getServerApi} from '../../config/deployment'

let envUri = getServerApi()
var buildingServiceUrl = envUri+"/api/building/full"

export const getBuilding = (ehakCode, buildingNr, apartmentNr) => {
    return new Promise((resolve, reject) => {
        axios.get(buildingServiceUrl, {
            params: {
                ehrBuildCode: ehakCode,
                number: buildingNr,
                apartNumber: apartmentNr,
                apiKey: "abg34sdusf893LAD3d7adNFLnas"
            }
          })
          .then(res => {
            if(res.data.data) resolve(res.data.data)
            reject("not found")
          })
          .catch(err => {
            reject(err)
          })
    })
    
}



// WEBPACK FOOTER //
// ./src/building/services/buildingSerivce.js